import { useQuery } from "react-query";
import { getDomesticBranchesParams } from "./gateway";

function useGetDomesticBranchesParams() {
  return useQuery({
    queryFn: getDomesticBranchesParams,
    queryKey: "getDomesticBranchesParams",
  });
}

export default useGetDomesticBranchesParams;
